export default __webpack_public_path__ + "static/media/identity.810c0e36.svg";